import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import Questionnaire from 'components/Questionnaire';

export const QuestionaireContext = createContext();

export const QuestionaireContextProvider = ({
  open = false,
  defaultType,
  apiKey,
  entityId = null,
  children,
  onCloseCallback = () => null,
}) => {
  const [isOpen, setIsOpen] = useState(open);
  const [profileId, setProfileId] = useState(null);
  const [type, setType] = useState(defaultType);
  const [matches, setMatches] = useState(false);
  const handleClose = () => {
    setIsOpen(false);
    setMatches(false);
    onCloseCallback();
  };

  const openWithProfileIdAndType = (id, type) => {
    setType(type);
    setProfileId(id);
    setIsOpen(true);
  };

  return (
    <QuestionaireContext.Provider
      value={{ isOpen, setIsOpen, type, setType, apiKey, setMatches, openWithProfileIdAndType }}
    >
      {children}
      <Questionnaire
        apiKey={apiKey}
        closeModal={handleClose}
        isOpen={isOpen}
        showMatches={matches}
        type={type}
        entityId={entityId}
        profileId={profileId}
      />
    </QuestionaireContext.Provider>
  );
};

QuestionaireContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool,
  defaultType: PropTypes.string,
  entityId: PropTypes.number,
  apiKey: PropTypes.string,
  onCloseCallback: PropTypes.func,
};
